import { Component } from '@angular/core';

@Component({
    selector: 'app-update-distributor-stock',
    templateUrl: './update-distributor-stock.component.html',
    standalone: false
})
export class UpdateDistributorStockComponent {}
